window.hasInitializedGAEvents = {};

// Функция инициализации GA4 события
function triggerGAEvent(eventName, params = {}) {
  if (!window.hasInitializedGAEvents[eventName]) {
    gtag('event', eventName, params);
    window.hasInitializedGAEvents[eventName] = true;
  }
}

// Флаг для предотвращения повторного выполнения UET событий
window.hasInitializedUETEvents = {};

// Функция инициализации UET события
function triggerUETEvent(eventName, params = {}) {
  if (!window.hasInitializedUETEvents[eventName]) {
    if (window.uetq) {
      uetq.push('event', eventName, params);
      window.hasInitializedUETEvents[eventName] = true;
    } else {
      console.error("UET script is not initialized.");
    }
  }
}

// Находим элементы
const hamburgerMenu = document.getElementById('hamburger-menu');
const mobileHamburger = document.getElementById('mobile-hamburger');
const desktopHamburgers = document.querySelectorAll('.desktop-hamburger');
const hamburgerIcons = document.querySelectorAll('.hamburger-icon');
const closeIcons = document.querySelectorAll('.close-icon');
const menuCenter = document.getElementById('menu-center');


function toggleMobileMenu() {

  hamburgerMenu.classList.toggle('hidden');
  hamburgerMenu.classList.toggle('opacity-0');

  hamburgerIcons.forEach(icon => icon.classList.toggle('hidden'));
  closeIcons.forEach(icon => icon.classList.toggle('hidden'));

  document.body.classList.toggle('overflow-hidden');
}

// Функция для десктопной кнопки
function toggleDesktopMenu() {
  // Отображаем/скрываем оверлей
  hamburgerMenu.classList.toggle('hidden');
  hamburgerMenu.classList.toggle('opacity-0');
  // Дополнительно показываем/скрываем nav (menu-center)
  // (если вам действительно нужно открывать ту же самую панель на десктопе)
  menuCenter.classList.toggle('hidden');

  // Переключаем иконки
  hamburgerIcons.forEach(icon => icon.classList.toggle('hidden'));
  closeIcons.forEach(icon => icon.classList.toggle('hidden'));

  document.body.classList.toggle('overflow-hidden');
}

// Вешаем обработчик клика на мобильную кнопку (если она есть)
if (mobileHamburger) {
  mobileHamburger.addEventListener('click', toggleMobileMenu);
}

// Вешаем обработчики клика на все десктопные кнопки (если есть несколько)
if (desktopHamburgers.length) {
  desktopHamburgers.forEach(hamburger => {
    hamburger.addEventListener('click', toggleDesktopMenu);
  });
}


// Search Functionality
const searchToggles = document.querySelectorAll('.search-toggle');

searchToggles.forEach(function (searchToggle) {
  const searchContainer = searchToggle.closest('.search-container');
  if (!searchContainer) return;
  const searchForm = searchContainer.querySelector('.search-form');
  if (!searchForm) return;
  const searchInput = searchForm.querySelector('input[name="q"]');
  const predictiveResults = searchContainer.querySelector('.predictive-search-results');

  // Click handler for the search icon
  searchToggle.addEventListener('click', function (e) {
    e.preventDefault();
    searchContainer.classList.toggle('active');

    if (searchContainer.classList.contains('active')) {
      // Show the search form
      searchForm.classList.remove('hidden', 'opacity-0');
      searchForm.classList.add('opacity-100');
      searchInput.focus();
    } else {
      // Hide the search form
      searchForm.classList.add('hidden', 'opacity-0');
      searchForm.classList.remove('opacity-100');
    }
  });

  // Close the form when clicking outside
  document.addEventListener('click', function (e) {
    if (!searchContainer.contains(e.target) && !searchToggle.contains(e.target) && searchContainer.classList.contains('active')) {
      searchContainer.classList.remove('active');
      searchForm.classList.add('hidden', 'opacity-0');
      searchForm.classList.remove('opacity-100');
      if (predictiveResults) predictiveResults.classList.add('hidden');
    }
  });

  // Close the form when pressing Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchContainer.classList.contains('active')) {
        searchContainer.classList.remove('active');
        searchForm.classList.add('hidden', 'opacity-0');
        searchForm.classList.remove('opacity-100');
        if (predictiveResults) predictiveResults.classList.add('hidden');
      }
    }
  });

  // Handle input in the search field
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const query = searchInput.value.trim();

      if (query.length > 0) {
        fetchPredictiveSearchResults(query, predictiveResults);
      } else {
        if (predictiveResults) {
          predictiveResults.classList.add('hidden');
          predictiveResults.innerHTML = '';
        }
      }
    });
  }
});

var loadProductRecommendationsIntoSection = function () {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector('.product-recommendations');
  if (productRecommendationsSection === null) {
    return;
  }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = baseUrl + '?section_id=product-recommendations&product_id=' + productId + '&limit=' + limit;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open('GET', requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement('div');
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML =
        container.querySelector('.product-recommendations').innerHTML;

      // Attach event listener to "Add to Cart" buttons after new content is loaded
      attachAddToCartListeners();
    }
  };
  request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener('shopify:section:load', function (event) {
  if (event.detail.sectionId === 'product-recommendations') {
    loadProductRecommendationsIntoSection();
  }
});

loadProductRecommendationsIntoSection();

// Function to fetch predictive search results
function fetchPredictiveSearchResults(query, predictiveResults) {
  if (!predictiveResults) return;
  fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
    .then((response) => response.json())
    .then((data) => {
      displayPredictiveSearchResults(data.resources.results.products, predictiveResults);
    })
    .catch((error) => {
      console.error('Error fetching predictive search results:', error);
    });
}

// Function to display predictive search results
function displayPredictiveSearchResults(products, predictiveResults) {
  if (!predictiveResults) return;
  if (products.length > 0) {
    let resultsHTML = '<ul>';

    products.forEach((product) => {
      resultsHTML += `
        <li>
          <a href="${product.url}">
            <div class="flex items-center">
              <img loading="lazy" src="${product.featured_image.url}" alt="${product.title}" class="w-12 h-12 mr-4 object-cover">
              <div>
                <p class="font-medium text-sm">${product.title}</p>
                <p class="text-xs text-gray-500">$${ product.price }</p>
              </div>
            </div>
          </a>
        </li>
      `;
    });

    resultsHTML += '</ul>';
    predictiveResults.innerHTML = resultsHTML;
    predictiveResults.classList.remove('hidden');
  } else {
    predictiveResults.innerHTML = '<p class="p-4 text-gray-500">No results found.</p>';
    predictiveResults.classList.remove('hidden');
  }
}


// Smooth Scrolling for Anchor Links
const anchorLinks = document.querySelectorAll('a[href^="#"]');

anchorLinks.forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: 'smooth'
      });
    }
  });
});

// Smooth Scrolling if Page is Loaded with Anchor Link
window.addEventListener('load', () => {
  const hash = window.location.hash;
  if (hash) {
    const targetElement = document.getElementById(hash.substring(1));
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: 'smooth'
      });
    }
  }
});

function attachAddToCartListeners() {
  document.querySelectorAll('.add-to-cart-btn').forEach(function (button) {
    button.removeEventListener('click', addToCartHandler); 
    button.addEventListener('click', addToCartHandler);
  });
}


(function storeUTMs() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  utmParams.forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      sessionStorage.setItem(param, value);
    }
  });
})();


async function addToCartHandler() {
    const productId = this.dataset.id;
    const quantityInput = document.querySelector('#quantity');
    const quantity = parseInt(quantityInput?.value || '1');
    const addToCartButton = this;
    const discountCode = 'WELCOME15';

    const originalButtonContent = 'ADD TO CART';
    addToCartButton.innerHTML = `<span>Adding...</span>`;
    addToCartButton.disabled = true;
    addToCartButton.classList.add('cursor-not-allowed', 'opacity-50');

    try {
        const utmData = {
            utm_source: sessionStorage.getItem('utm_source'),
            utm_medium: sessionStorage.getItem('utm_medium'),
            utm_campaign: sessionStorage.getItem('utm_campaign'),
            utm_term: sessionStorage.getItem('utm_term'),
            utm_content: sessionStorage.getItem('utm_content')
        };

        //Additing to the cart
        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: productId,
                quantity: quantity,
                ...utmData
            })
        });

        if (!addResponse.ok) throw await addResponse.json();

        //Apply promocode after additing to the cart
        const discountResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json', 
                'Accept': 'application/json' 
            },
            body: JSON.stringify({ discount: discountCode })
        });

        const cartData = await discountResponse.json();

        console.log('=== PROMO DEBUG ===');
        console.log('Cart data:', cartData);
        console.log('discount_codes:', cartData.discount_codes);
        console.log('discount_applications:', cartData.discount_applications);
        
        const promoEl = document.getElementById('applied-promo');
        console.log('Promo element exists:', !!promoEl);
        console.log('===================');

        updateCartContents(cartData);
        updateShippingText();

        updatePromoUI(cartData);

        openCart();

    } catch (error) {
        console.error('Error:', error);

    } finally {
        addToCartButton.innerHTML = originalButtonContent;
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('cursor-not-allowed', 'opacity-50');
    }
}

function removePromoBanner() {
  const banners = document.querySelectorAll('#promo-applied-banner');
  banners.forEach(b => b.remove());
}

function updatePromoUI(cart) {
  const oldBanners = document.querySelectorAll('#promo-applied-banner');
  oldBanners.forEach(banner => banner.remove());
  
  if (Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0) {
    const applied = cart.discount_codes.find(d => d.applicable);
    
    if (applied) {
      const promoContainer = document.querySelector('label[for="promo-code"]');
      
      if (promoContainer) {
        const promoEl = document.createElement('div');
        promoEl.id = 'promo-applied-banner';
        promoEl.className = 'text-green-400';
        promoEl.textContent = `Promo code "${applied.code}" applied!`;
        
        promoContainer.appendChild(promoEl);
      }
    }
  }
}

/*async function addToCartHandler() {
    const productId = this.dataset.id;
    const quantityInput = document.querySelector('#quantity');
    const quantity = parseInt(quantityInput?.value || '1');
    const addToCartButton = this;


    const originalButtonContent = 'ADD TO CART';
    addToCartButton.innerHTML = `<span>Adding...</span>`;
    addToCartButton.disabled = true;
    addToCartButton.classList.add('cursor-not-allowed', 'opacity-50');

    try {
        const utmData = {
            utm_source: sessionStorage.getItem('utm_source'),
            utm_medium: sessionStorage.getItem('utm_medium'),
            utm_campaign: sessionStorage.getItem('utm_campaign'),
            utm_term: sessionStorage.getItem('utm_term'),
            utm_content: sessionStorage.getItem('utm_content')
        };

        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: productId,
                quantity: quantity,
                discount_code: 'WELCOME15',
                ...utmData
            })
        });

        if (!addResponse.ok) throw await addResponse.json();

        const cartResponse = await fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        const cartData = await cartResponse.json();

        updateCartContents(cartData);
        updateShippingText();
        openCart();

    } catch (error) {
        console.error('Error:', error);
        notie.alert({
            type: 3,
            text: error.message,
            position: 'top'
        });
    } finally {
        addToCartButton.innerHTML = originalButtonContent;
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('cursor-not-allowed', 'opacity-50');
    }
}*/


function updateShippingText() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const shippingElement = document.querySelector('.cart-subtotal--shipping');
      if (!shippingElement) return;

      let hasStand = false;
      cart.items.forEach(item => {
        if (item.product_title.toLowerCase().includes('christmas tree stand')) {
          hasStand = true;
        }
      });

      if (cart.total_price > 7500 || hasStand) {
        shippingElement.textContent = 'Free Shipping';
      } else {
        shippingElement.textContent = 'Shipping and taxes calculated at checkout.';
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

function truncateText(text, maxLength = 40) {
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}

// Ensure to call attachAddToCartListeners() when the page is loaded
document.addEventListener('DOMContentLoaded', function () {
  attachAddToCartListeners();
});
// Function to load recommended products into the cart
async function loadRecommendedProducts(productId) {
  console.log('productId', productId);
  if (!productId || isNaN(Number(productId)) || Number(productId) <= 0) {
    productId = '9822885511489';
  }
  fetch(`/recommendations/products.json?product_id=${productId}&limit=10`)
    .then(response => response.json())
    .then(data => {
      const recommendedProductsContainer = document.getElementById('recommended-products');
      recommendedProductsContainer.innerHTML = '';

      

      if (data.products && data.products.length > 0) {
        data.products.forEach(product => {
          const truncatedTitle = truncateText(product.title, 40);
          const productHtml = `
            <div class="swiper-slide">
              <a href="${product.url}" class="block text-center">
                <img src="${product.featured_image}" alt="${product.title}" class="h-32 object-cover">
                <p class="mt-2 text-white text-sm font-medium" title="${product.title}">${truncatedTitle}</p>
                <p class="text-sm text-azalea">${formatMoney(product.price)}</p>
              </a>
            </div>
          `;
          recommendedProductsContainer.insertAdjacentHTML('beforeend', productHtml);
        });

        // Initialize Swiper slider after recommended products are loaded
        new Swiper('.swiper-container', {
          slidesPerView: 3.3,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          loop: true
        });

                        const nextArrowSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="12" stroke="#fff" viewBox="0 0 320 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path class="fill-white hover:fill-azalea-d" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>
    `;
  const prevArrowSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="12" stroke="#fff" viewBox="0 0 320 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path class="fill-white hover:fill-azalea-d" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
    `;


  // Add custom SVG arrows to navigation buttons
  document.querySelector('.swiper-next').innerHTML = nextArrowSvg;
  document.querySelector('.swiper-prev').innerHTML = prevArrowSvg;
      }
    })
    .catch(error => {
      console.error('Error loading recommended products:', error);
    });
}





    document.addEventListener('DOMContentLoaded', function() {
       // Arrow SVG Customizations

      // Initialize Swiper instances
      var swiperThumbs = window.innerWidth >= 768 ? new Swiper('.swiper-thumbs', {
        spaceBetween: 0,
        slidesPerView: 5,
        direction: 'vertical',
    
      }) : null;

      var swiperMain = new Swiper('.swiper-main', {
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: false,
        thumbs: swiperThumbs ? { swiper: swiperThumbs } : null,
      });
        const nextArrowSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="12" viewBox="0 0 26 12" fill="none">
      <path d="M20 1L25 6M25 6L20 11M25 6L1 6" stroke="#4B4949" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  const prevArrowSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="12" viewBox="0 0 26 12" fill="none">
      <path d="M6 11L1 6M1 6L6 1M1 6L25 6" stroke="#4B4949" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  // Add custom SVG arrows to navigation buttons
  document.querySelector('.swiper-button-next').innerHTML = nextArrowSvg;
  document.querySelector('.swiper-button-prev').innerHTML = prevArrowSvg;
    });

// Cart Functionality
const cartElement = document.getElementById('slide-over-cart');
const cartPanel = document.getElementById('cart-panel');
const cartOverlay = document.getElementById('cart-overlay');
const openCartButtons = document.querySelectorAll('.open-cart');
const closeCartButtons = document.querySelectorAll('.close-cart');

// Custom money formatting function
function formatMoney(cents, format = '${{amount}}') {
  const value = cents / 100;
  const formattedValue = format.replace('{{amount}}', value.toFixed(2));
  return formattedValue;
}




// Function to open the cart
function openCart() {
  cartElement.classList.remove('hidden');
  void cartElement.offsetWidth;
  cartOverlay.classList.remove('opacity-0');
  cartOverlay.classList.add('opacity-100');
  cartPanel.classList.remove('translate-x-full');
  cartPanel.classList.add('translate-x-0');
  document.body.classList.add('overflow-hidden');
  updateCartContents();

  // Fetch the cart contents to get the last product added
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.items.length > 0) {
        const lastProduct = cart.items[cart.items.length - 1]; // Get the last item
        const productId = lastProduct.product_id; // Extract the product ID
        loadRecommendedProducts(productId); // Pass the product ID to the recommended products function
      } else {
        console.warn('Cart is empty. Cannot determine the last product added.');
      }
    })
    .catch(error => {
      console.error('Failed to fetch cart contents:', error);
    });
}

// Function to check if the cart should be opened automatically
function checkForAutoOpenCart() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('cart') === 'true') {
    openCart();
  }
}

// Run the check on page load
document.addEventListener('DOMContentLoaded', () => {
  checkForAutoOpenCart();
});

// Function to close the cart
function closeCart() {
    removePromoBanner();
    const promoEl = document.getElementById('applied-promo');
    if (promoEl) {
       promoEl.textContent = '';
       promoEl.classList.add('hidden');
    }



  cartOverlay.classList.remove('opacity-100');
  cartOverlay.classList.add('opacity-0');
  cartPanel.classList.remove('translate-x-0');
  cartPanel.classList.add('translate-x-full');
  cartOverlay.classList.add('hidden');
  cartElement.classList.add('hidden');
  cartPanel.addEventListener('transitionend', onTransitionEnd);
  document.body.classList.remove('overflow-hidden');
  function onTransitionEnd(event) {
    if (event.propertyName === 'transform') {
      cartElement.classList.add('hidden');
      cartPanel.removeEventListener('transitionend', onTransitionEnd);
    }
  }
}

// Add click event to all 'open-cart' buttons
openCartButtons.forEach(button => {
  button.addEventListener('click', openCart);
});

// Add click event to all 'close-cart' buttons
closeCartButtons.forEach(button => {
  button.addEventListener('click', closeCart);
});

// Add click event to the overlay to close the cart
cartOverlay.addEventListener('click', closeCart);

// Ajax Add to Cart functionality
/*document.querySelectorAll('.add-to-cart-btn').forEach(function (button) {
  button.addEventListener('click', async function () {
    const productId = this.dataset.id;
    const addToCartButton = this;

    // Store the original button content
    const originalButtonContent = 'ADD TO CART';

    // Set the button to the loading state
    addToCartButton.innerHTML = `
<svg aria-hidden="true" role="status" class="inline w-4 h-4 me-3 mr-3 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#CD4E88"/>
<path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
</svg>
<span pl-3>Adding...</span>
    `;
    addToCartButton.disabled = true;
    addToCartButton.classList.add('cursor-not-allowed', 'opacity-50');

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      });

      if (!addResponse.ok) {
        const errorData = await addResponse.json();
        throw errorData;
      }

      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const cartData = await cartResponse.json();
      updateCartContents(cartData);
      updateShippingText();
      openCart();
    } catch (error) {
      console.error('Error:', error);
      notie.alert({ type: 3, text: error.message, position: 'top' });
      
    } finally {
      addToCartButton.innerHTML = originalButtonContent;
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('cursor-not-allowed', 'opacity-50');
    }
  });
});*/

// Update cart contents function
function updateCartContents(cartData = null) {

  const fetchCartData = cartData
    ? Promise.resolve(cartData)
    : fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response => response.json());

  fetchCartData
    .then(cart => {
      const cartItemsContainer = document.querySelector('.cart-items');
      cartItemsContainer.innerHTML = '';

      if (cart.items.length === 0) {
        cartItemsContainer.innerHTML = '<li class="text-white">Your cart is empty</li>';
      } else {
        cart.items.forEach((item, index) => {
          const lineNumber = index + 1;
          const imageUrl = getSizedImageUrl(item.image, '200x');
          const cartItemHtml = `
            <li class="flex py-6" data-id="${item.product_id}">
              <div class="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                <img loading="lazy" src="${imageUrl}" alt="${item.product_title}" class="h-full w-full object-cover object-center">
              </div>
              <div class="ml-4 flex flex-1 flex-col">
                <div>
                  <div class="flex justify-between text-base font-medium text-white">
                    <h3>
                      <a href="${item.url}">${item.product_title}</a>
                    </h3>
                    <div class="item-final-price ml-4"></div>
                  </div>
                </div>
                   <div class="flex flex-1 items-center justify-between text-sm mt-4">
                      <!-- Quantity Selector -->
                      <div class="flex items-center border border-gray-300 rounded-md bg-white" style="width: 180px;">
                        <button class="decrement-btn px-3 py-2 text-azalea-l text-lg font-semibold focus:outline-none" data-key="${ lineNumber }">-</button>
                        <input type="number" value="${ item.quantity }" class="w-full text-center border-none focus:outline-none quantity-input" data-key="${ lineNumber }">
                        <button class="increment-btn px-3 py-2 text-azalea-l text-lg font-semibold focus:outline-none" data-key="${ lineNumber }">+</button>
                      </div>
                      <div class="flex">
                        <svg width="18px" class="remove-item block fill-azalea hover:fill-azalea-d remove-item" xmlns="http://www.w3.org/2000/svg" data-key="${ lineNumber }" viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path class="fill-white hover:fill-azalea-d remove-item" data-key="${ lineNumber }" d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                      </div>
                    </div>
              </div>
            </li>
          `;
          cartItemsContainer.insertAdjacentHTML('beforeend', cartItemHtml);
        });
      }

      // Update cart subtotal
      const cartSubtotalElement = document.querySelector('.cart-subtotal');
      if (cartSubtotalElement) {
        cartSubtotalElement.textContent = formatMoney(cart.total_price);
        cartSubtotalElement.dataset.amount = cart.total_price;
      }

      // Update discount amount
      const discountEl = document.querySelector('.total-discount');
      if (discountEl && cart.total_discount > 0) {
        discountEl.textContent = '- ' + formatMoney(cart.total_discount);
        discountEl.dataset.amount = cart.total_discount;
        discountEl.classList.remove('hidden');
      } else if (discountEl) {
        discountEl.classList.add('hidden');
      }

      // Update original price (strikethrough)
      const originalEl = document.querySelector('.org-total-price');
      if (originalEl && cart.total_discount > 0) {
        originalEl.textContent = formatMoney(cart.original_total_price);
        originalEl.dataset.amount = cart.original_total_price;
        originalEl.classList.remove('hidden');
      } else if (originalEl) {
        originalEl.classList.add('hidden');
      }

      // Update discount title
      const discountTitleContainer = document.querySelector('.flex.justify-between.text-sm.text-white.mb-2');
      if (cart.discount_applications && cart.discount_applications.length > 0) {
        if (discountTitleContainer) {
          const titleEl = discountTitleContainer.querySelector('p');
          if (titleEl) {
            titleEl.textContent = cart.discount_applications.map(d => d.title).join(', ');
          }
          discountTitleContainer.classList.remove('hidden');
        }
      } else if (discountTitleContainer) {
        discountTitleContainer.classList.add('hidden');
      }

      // Update promo code applied message
      const promoEl = document.getElementById('applied-promo');
      if (!promoEl) return;

      const hasItems = cart.items?.length > 0;
      const appliedCode = cart.discount_applications?.find(d => d.type === 'discount_code');

      if (hasItems && appliedCode) {
        promoEl.textContent = `Promo code "${appliedCode.title}" applied!`;
        promoEl.classList.remove('hidden');
      } else {
        promoEl.textContent = '';
        promoEl.classList.add('hidden');
      }

      // Update individual item prices
      cart.items.forEach(item => {
        const row = document.querySelector(`li[data-id="${item.product_id}"] .item-final-price`);
        if (!row) return;
        if (item.original_line_price > item.final_line_price) {
          row.innerHTML = `
            <p class="text-gray-400 line-through text-sm">${formatMoney(item.original_line_price)}</p>
            <p class="text-azalea">${formatMoney(item.final_line_price)}</p>
          `;
        } else {
          row.innerHTML = `<p>${formatMoney(item.final_line_price)}</p>`;
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart contents:', error);
    });
}

// Function to get product IDs from the cart
function getCartProductIds() {
    return new Promise(resolve => setTimeout(resolve, 1000)) 
        .then(() => fetch('/cart.js'))
        .then(response => response.json())
        .then(cart => {
            if (cart.items && cart.items.length > 0) {
                // Последний добавленный товар
                const lastAddedItem = cart.items.slice(-1)[0];
                return lastAddedItem.id;
            } else {
                throw new Error('No items in the cart');
            }
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
            return [];
        });
}











// Helper function to get sized image URL
function getSizedImageUrl(src, size) {
  if (!src) return '';
  return src.replace(/(\.[^.]*)$/, `_${size}$1`);
}


// Accordion Toggle Function
function toggleAccordion(index) {
  const content = document.getElementById(`content-${index}`);
  const icon = document.getElementById(`icon-${index}`);

  // SVG for Minus icon
  const minusSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
      <path d="M3.75 7.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" />
    </svg>
  `;

  // SVG for Plus icon
  const plusSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
      <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
    </svg>
  `;

  // Toggle the content's max-height for smooth opening and closing
  if (content.style.maxHeight && content.style.maxHeight !== '0px') {
    content.style.maxHeight = '0';
    icon.innerHTML = plusSVG;
  } else {
    content.style.maxHeight = content.scrollHeight + 'px';
    icon.innerHTML = minusSVG;
  }
}


// slide-over-cart.liquid or theme.liquid (wherever your cart JS is)
document.addEventListener('DOMContentLoaded', function() {
  const cartPanel = document.getElementById('slide-over-cart');



  // Delegate event listener to the cart panel for efficiency
  cartPanel.addEventListener('click', function(event) {
    console.log(event.target);
    if (event.target.matches('.increment-btn')) {
      updateQuantity(event.target.dataset.key, 1);  // Use line number
    } else if (event.target.matches('.decrement-btn')) {
      updateQuantity(event.target.dataset.key, -1);  // Use line number
    } else if (event.target.matches('.remove-item')) {
      
      updateQuantity(event.target.dataset.key, 0);
    } else if (event.target.matches('.quantity-input')) {
      event.target.addEventListener('change', function(evt) {
        if (evt.target.value < 1) {
          evt.target.value = 1;
        }
        updateQuantity(evt.target.dataset.key, 0, evt.target.value);  // Use line number
      });
    }
  });

  function updateQuantity(line, change, inputVal = null) {
    let quantity;

    if (change !== 0) { // for increment/decrement buttons
      const lineItem = cartPanel.querySelector(`.quantity-input[data-key="${line}"]`);
      quantity = parseInt(lineItem ? lineItem.value : 0) + change;

      if (quantity < 1) {
        quantity = 1;
      }

      if (lineItem) lineItem.value = quantity;
    } else if (inputVal !== null) { // for direct input change
      quantity = parseInt(inputVal);
    } else { // for removing the item
      quantity = 0;
    }

    // Send the updated quantity to the server
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,  // Pass the line number (data-line attribute)
        quantity: quantity,  // Set quantity to 0 for removing
      }),
    })
    .then(response => response.json())
    .then(cart => {
      updateCart(cart);
    })
    .catch((error) => {
      console.error('Error updating cart:', error);
    });
  }

  function updateCart(cart) {
    const cartItemsContainer = cartPanel.querySelector('.cart-items');
    const subtotalElement = cartPanel.querySelector('.cart-subtotal');
    cartItemsContainer.innerHTML = '';  // Clear existing items

          const currentProductId = getCartProductIds();
      loadRecommendedProducts(currentProductId);

    if (cart.item_count > 0) {
      cart.items.forEach((item, index) => {
        const lineNumber = index + 1;  // Line number is the index + 1
        const listItem = document.createElement('li');
        listItem.classList.add('flex', 'py-6');

        const itemHtml = `
          <div class="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-mulch-l">
            <img src="${item.image}" alt="${item.product_title}" class="h-full w-full object-cover object-center">
          </div>
          <div class="ml-4 flex flex-1 flex-col">
            <div>
              <div class="flex justify-between text-base font-medium text-white">
                <h3>
                  <a href="${item.url}">${item.product_title}</a>
                </h3>
                <p  class="ml-4 ">${formatMoney(item.final_line_price)}</p>
              </div>
            </div>
            <div class="flex flex-1 items-center justify-between text-sm mt-4">
              <div class="flex items-center border border-gray-300 rounded-md bg-white" style="width: 180px;">
                <button class="decrement-btn px-3 py-2 text-azalea-l text-lg font-semibold focus:outline-none" data-key="${lineNumber}">-</button>
                <input type="number" value="${item.quantity}" class="w-full text-center border-none focus:outline-none quantity-input" data-key="${lineNumber}">
                <button class="increment-btn px-3 py-2 text-azalea-l text-lg font-semibold focus:outline-none" data-key="${lineNumber}">+</button>
              </div>
              <div class="flex">
                <svg width="18px" data-key="${lineNumber}" class="remove-item block fill-azalea hover:fill-azalea-d remove-item" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path class="fill-white hover:fill-azalea-d remove-item" data-key="${ lineNumber }" d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
              </div>
            </div>
          </div>
        `;
        listItem.innerHTML = itemHtml;
        cartItemsContainer.appendChild(listItem);
      });

      subtotalElement.textContent = formatMoney(cart.total_price); // Update subtotal
    } else {
      cartItemsContainer.innerHTML = '<li class="text-white">Your cart is empty</li>';
    }
  }
    const currentProductId = getCartProductIds();

  loadRecommendedProducts(currentProductId);
});




document.addEventListener('DOMContentLoaded', function () {
  const incrementButton = document.getElementById('increment');
  const decrementButton = document.getElementById('decrement');
  const quantityInput = document.getElementById('quantity');
  const priceDisplays = document.querySelectorAll('.current-price');
  const comparePriceDisplays = document.querySelectorAll('.compare-price');
let priceInCents = 0;
let comparePriceInCents = 0;

const priceElement = document.getElementById('price-in-cents');
const comparePriceElement = document.getElementById('compare-price-in-cents');


if (priceElement) {

  priceInCents = parseInt(priceElement.value) || 0;
}

if (comparePriceElement) {
  comparePriceInCents = parseInt(comparePriceElement.value) || 0;
}


  // Function to update the displayed prices
  function updatePrice() {
    const quantity = parseInt(quantityInput.value);
    const newPrice = priceInCents * quantity;
    
    priceDisplays.forEach(priceDisplay => {
      priceDisplay.textContent = formatMoney(newPrice);
    });

    if (comparePriceInCents > priceInCents) {
      const newComparePrice = comparePriceInCents * quantity;
      comparePriceDisplays.forEach(comparePriceDisplay => {
        comparePriceDisplay.textContent = formatMoney(newComparePrice);
        comparePriceDisplay.classList.remove('hidden');
      });
    } else {
      comparePriceDisplays.forEach(comparePriceDisplay => {
        comparePriceDisplay.classList.add('hidden');
      });
    }
  }

  // Event Listeners for Quantity Buttons
  incrementButton.addEventListener('click', () => {
    console.log('click to incrementButton');
    quantityInput.value = parseInt(quantityInput.value) + 1;
    updatePrice();
  });

  decrementButton.addEventListener('click', () => {
    console.log('click to decrementButton');
    if (quantityInput.value > 1) {
      quantityInput.value = parseInt(quantityInput.value) - 1;
      updatePrice();
    }
  });

  // Event listener for manual quantity input change
  quantityInput.addEventListener('change', () => {
    if (quantityInput.value < 1) {
      quantityInput.value = 1;
    }
    updatePrice();
  });

  // Initial price update
  updatePrice();

});

  document.addEventListener('DOMContentLoaded', function() {
    let currentPage = 1;  // Start from page 1
    const loadMoreButton = document.getElementById('load-more'); // Load more button
    const productGrid = document.getElementById('product-grid'); // Product grid container

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function() {
        currentPage += 1; // Increment the page number
        const nextPageUrl = `?page=${currentPage}`; // Construct the next page URL

        // Fetch the next page
        fetch(nextPageUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'text/html'
          }
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text(); // Return the HTML response
        })
        .then(data => {
          // Parse the HTML string to a DOM document
          const parser = new DOMParser();
          const parsedDocument = parser.parseFromString(data, 'text/html');

          // Select all product elements from the parsed document
          const newProducts = parsedDocument.querySelectorAll('#product-grid .product-card');
          
          if (newProducts.length > 0) {
            newProducts.forEach(product => {
              productGrid.appendChild(product); // Append new products to the product grid
            });
          }

          // If fewer than 12 products are loaded, hide the load more button
          if (newProducts.length < 12) {
            loadMoreButton.style.display = 'none'; // Hide the load more button if there's no more content
          }
        })
        .catch(error => {
          console.error('Error loading more products:', error);
        });
      });
    }
  });


    var swiper = new Swiper('.swiper-story', {
        slidesPerView: 1.2, // Display 1.2 slides
        mousewheel: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
        },
        spaceBetween: 30, // Space between slides in px
        loop: false,
        // Optional: Add pagination or navigation if desired
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        breakpoints: {
          // Adjust slidesPerView for different screen sizes
          640: {
            slidesPerView: 1.2,
          },
          768: {
            slidesPerView: 1.2,
          },
          1024: {
            slidesPerView: 1.2,
          },
        },
      });  

document.addEventListener('DOMContentLoaded', function() {
      const swiper = new Swiper('.testimonial-container', {
        autoHeight: true, 
        centeredSlides: true,
        spaceBetween: 16,
        loop: true,
        loopedSlides: 15,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        grabCursor: true,
        speed: 2000,
        breakpoints: {
          425: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2.5,
          },
          1024: {
            slidesPerView: 3,
          },
          1366: {
            slidesPerView: 5,
            
          },
        },
        
      });
    });


          let swiperEndReached = false;
      var swiper = new Swiper('.slide-product-card', {
  mousewheel: {
    enabled: true,
    forceToAxis: true,
    sensitivity: 0,
    releaseOnEdges: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },
  spaceBetween: 16,
  loop: false,
  breakpoints: {
   450: {
      slidesPerView: 1.2
   },
   740: {
      slidesPerView: 2
   },
   1024: {
      slidesPerView: 3.2
   },
   1366: {
    slidesPerView: 4
   },
   1600: {
      slidesPerView: 4.3
   },
  },
  on: {



    reachEnd: function () {
      swiperEndReached = true;
    },
    fromEdge: function () {
      swiperEndReached = false;
    },
  },
});

// Ensure mousewheel control is enabled
swiper.mousewheel.enable();

  swiper.on('scroll', function (e) {
    if (swiperEndReached) {
      // Если достигнут конец и пользователь прокручивает дальше
      window.scrollBy({
        top: window.innerHeight,
        behavior: 'smooth'
      });
      swiperEndReached = false; // Сброс флага, чтобы прокрутить страницу только один раз
    }
  });